import { useMediaQuery } from "react-responsive";
import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";
import { useEffect } from "react";

export const Header: React.FC = () => {
  const mobile = useMediaQuery({ maxWidth: 800 });

  useEffect(() => {
    console.log("mobile: ", mobile);
  }, [mobile]);

  if (typeof mobile !== "boolean" || typeof window === "undefined") return null;
  else if (mobile) return <MobileHeader />;
  else return <DesktopHeader />;
};